export const parseArray = (str) => {
  const trimmedStr = str.slice(1, str.length - 1);

  const arr = trimmedStr
    .split(",")
    .map((element) => element.trim().replace(/^'|'$/g, ""));

  return arr;
};
